import { useState, useEffect } from 'react';

// Mesmo corte usado nos frameworks mais comuns (~tablet retrato pra baixo).
// O app inteiro é desktop-first (sidebar fixa + abas) — esse hook só serve
// pra decidir se redireciona pro modo simplificado de Relatórios, não pra
// deixar o resto das telas responsivo.
const MOBILE_BREAKPOINT_PX = 768;

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX}px)`).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX}px)`);
    const handler = e => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
